import React from 'react';
import ReactDOM from 'react-dom/client';
import OverdriveArena from './OverdriveArena';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <OverdriveArena />
  </React.StrictMode>
);
